import { getEmpsExcelExportAPI } from '../services/employee'
import useExportPimEmployeeExcel from './use-export-pim-employee-excel'

/**
 * Downloads the regular "ข้อมูลพนักงาน" PIM export. Backend streams a real .xlsx (Meegle 14443031
 * follow-up) instead of the client-side workbook `ExportExcel2.jsx` used to build — this reuses
 * `useExportPimEmployeeExcel`'s fetch/save-as-file wiring, only swapping the endpoint and the
 * fallback filename (kept as the old client-side export's fixed "New Employee.xlsx" per the card).
 */
export default function useExportPimEmployeeExcelRegular() {
  return useExportPimEmployeeExcel({
    apiFn: getEmpsExcelExportAPI,
    defaultFilename: 'New Employee.xlsx'
  })
}
